import React from 'react';
import styled from 'styled-components';
import { lightGrey2Color, redColor } from 'js/config/style';

export default styled(({ disabled, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.75 27.66" {...rest}>
    <path
      className="trash-can"
      d="M3.17,7.2H20.6a0,0,0,0,1,0,0v18a2.43,2.43,0,0,1-2.43,2.43H5.59a2.43,2.43,0,0,1-2.43-2.43V7.2a0,0,0,0,1,0,0Z"
    />
    <line className="trash-lid lid-base" x1="1.5" y1="3.77" x2="22.25" y2="3.77" />
    <circle className="trash-lid lid-top" cx="11.62" cy="2.26" r="2.26" />
  </svg>
))`
  position: relative;
  top: -1px;

  .trash-can,
  .lid-top {
    fill: ${({ disabled }) => (disabled ? lightGrey2Color : redColor)};
  }

  .lid-base {
    fill: none;
    stroke: ${({ disabled }) => (disabled ? lightGrey2Color : redColor)};
    stroke-linecap: round;
    stroke-miterlimit: 10;
    stroke-width: 3px;
  }
`;
